import { render, staticRenderFns } from "./maintenance.vue?vue&type=template&id=4ffe0a82&scoped=true"
import script from "./maintenance.vue?vue&type=script&lang=js"
export * from "./maintenance.vue?vue&type=script&lang=js"
import style0 from "./maintenance.vue?vue&type=style&index=0&id=4ffe0a82&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ffe0a82",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gameclient/gameclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ffe0a82')) {
      api.createRecord('4ffe0a82', component.options)
    } else {
      api.reload('4ffe0a82', component.options)
    }
    module.hot.accept("./maintenance.vue?vue&type=template&id=4ffe0a82&scoped=true", function () {
      api.rerender('4ffe0a82', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/maintenance.vue"
export default component.exports